// DurationSelector — ActivityWizard Steg 2 (delspår 3c). Längd-pills (flyttad från
// 3d). Options derived from the hall's min/max_duration_minutes in time_step
// increments (demo: 30/60/90/120). Selected = green fill.

import { cn } from "@/lib/utils";
import { useTranslation } from "react-i18next";

interface DurationSelectorProps {
  value: number | null;
  options: number[];
  onSelect: (minutes: number) => void;
}

export default function DurationSelector({ value, options, onSelect }: DurationSelectorProps) {
  const { t } = useTranslation("admin");
  return (
    <div className="grid grid-cols-4 gap-2">
      {options.map((min) => {
        const hrs = min / 60;
        const hoursLabel = Number.isInteger(hrs) ? String(hrs) : hrs.toFixed(1).replace(".", ",");
        const selected = value === min;
        return (
          <button
            key={min}
            type="button"
            aria-pressed={selected}
            data-testid={`duration-${min}`}
            onClick={() => onSelect(min)}
            className={cn(
              "flex flex-col items-center gap-0.5 rounded-xl border p-2.5 text-sm font-medium transition-colors",
              selected ? "livfull-pill-selected" : "border-border hover:border-primary/50",
            )}
          >
            <span>{t("activityWizard.step2.durationMinutes", { minutes: min, defaultValue: `${min} min` })}</span>
            <span className={cn("text-[11px] font-normal", selected ? "text-primary/70" : "text-muted-foreground")}>
              {t("activityWizard.step2.durationSubLabel", { hours: hoursLabel, defaultValue: `${hoursLabel} tim` })}
            </span>
          </button>
        );
      })}
    </div>
  );
}
